@if (viewMode === 'full' && attachments) {
  <app-ui-input
    class="search"
    [label]="'search' | translate"
    [placeholder]="'exServiceReport' | translate"
    [control]="searchForm.searchedText"
    [showClearButton]="true"
  ></app-ui-input>
}
@if (editMode && !disabled) {
  <app-ui-button
    class="add-attachment-button"
    (click)="openAddDialog()"
    [disabled]="disabled"
    [icon]="addButtonIcon"
    [buttonType]="addButtonType"
    text="{{ addButtonText | translate }}"
    [privilege]="addPrivilege"
    [adminPrivilege]="adminPrivilege"
  ></app-ui-button>
}
@if (!editMode && !passiveMode && !disabled) {
  <app-ui-button
    class="add-attachment-button"
    (click)="enableEdit()"
    [disabled]="disabled"
    [icon]="'edit'"
    text="{{ 'edit' | translate }}"
    [privilege]="enableEditPrivilege"
    [adminPrivilege]="adminPrivilege"
  ></app-ui-button>
}
@if (editMode && !passiveMode && !disabled) {
  <app-ui-button
    class="add-attachment-button"
    (click)="save()"
    [disabled]="disabled"
    [icon]="'save'"
    text="{{ 'save' | translate }}"
    [privilege]="savePrivilege"
    [adminPrivilege]="adminPrivilege"
  ></app-ui-button>
}
<ng-content></ng-content>
<div class="main">
  @if (attachments.errors?.sizeExceeded) {
    <div class="error">
      {{ 'newAttachmentsExceedsLimit' | translate: { maxSizeMB: maxSizeMB } }}
    </div>
  }
  <div class="main-container">
    @if (attachments.value?.length === 0) {
      <h3 class="statement">{{ 'noAttachments' | translate }}</h3>
    } @else {
      <ng-template
        [ngTemplateOutlet]="
          filteredAttachments?.length === 0 && viewMode === 'full' ? noMatch : data
        "
      ></ng-template>
    }
    <ng-template #noMatch>
      <h3 class="statement">
        {{ 'noMatchingAttachments' | translate }} "{{ searchedText.value }}"
      </h3>
    </ng-template>
    <ng-template #data>
      @for (attachment of filteredAttachments; track attachment.id) {
        <mat-card class="attachment-card">
          @if (downloadProgressMap[attachment.id]) {
            <mat-progress-bar
              mode="determinate"
              [value]="downloadProgressMap[attachment.id].progress"
            ></mat-progress-bar>
          }
          <img
            class="image"
            mat-card-image
            [src]="attachmentIcons[attachment.type] || attachmentIcons['other']"
            alt="{{ 'attachment' | translate }}"
          />
          <div
            class="attachment-info"
            [class.no-preview]="!((attachment | isPreviewable) && attachment.link)"
          >
            <p class="attachment-name" [title]="attachment.name">{{ attachment.name }}</p>
          </div>
          <div class="edit-and-delete-container">
            @if ((attachment | isPreviewable) && attachment.link) {
              <a
                (click)="openPreviewInPopup(attachment)"
                target="_blank"
                matTooltip="{{ 'preview' | translate }}"
              >
                <mat-icon class="preview-icon">visibility</mat-icon>
              </a>
            }
            @if (attachment.id !== 'new' && attachment.link) {
              <a
                (click)="openInNewTab(attachment.link)"
                target="_blank"
                [download]="attachment.name"
                matTooltip="{{ 'download' | translate }}"
              >
                <mat-icon class="download-icon">download</mat-icon>
              </a>
            }
            @if (editMode && !disabled) {
              <a (click)="openEditDialog(attachment)" matTooltip="{{ 'edit' | translate }}">
                <mat-icon>edit_note</mat-icon>
              </a>
              <a
                appConfirmDialog
                [confirmEntityName]="attachment.name"
                (confirmed)="delete(attachment)"
                color="warn"
                matTooltip="{{ 'delete' | translate }}"
              >
                <mat-icon>delete</mat-icon>
              </a>
            }
            <mat-icon [matMenuTriggerFor]="details" matTooltip="{{ 'info' | translate }}">
              info
            </mat-icon>
            <mat-menu #details="matMenu">
              <div class="pl-1 pr-1">
                <ng-container
                  *ngTemplateOutlet="attachmentDetails; context: { attachment: attachment }"
                ></ng-container>
              </div>
            </mat-menu>
          </div>
        </mat-card>
      }
    </ng-template>
  </div>
</div>

<!-- Reusable template for attachment details -->
<ng-template #attachmentDetails let-attachment="attachment">
  <p>
    {{ 'attachmentCategories' | translate }}
    <br />
    <span class="bold-text">
      {{ attachment.categories | translateArray: 'attachmentCategory' }}
    </span>
  </p>
  <p>
    {{ 'attachmentType' | translate }}
    <br />
    <span class="bold-text">{{ attachment.type }}</span>
  </p>
  <p>
    {{ 'fileSize' | translate }}
    <br />
    <span class="bold-text">{{ attachment.fileSize }}</span>
    {{ 'mb' | translate }}
  </p>
  @if (attachment.created) {
    <p>
      {{ 'created' | translate | lowercase }}
      <br />
      <span class="bold-text">{{ attachment.created }}</span>
    </p>
  }
  @if (attachment.createdBy) {
    <p>
      {{ 'createdBy' | translate }}
      <br />
      <span class="bold-text">{{ attachment.createdBy }}</span>
    </p>
  }
  @if (attachment.modified) {
    <p>
      {{ 'modified' | translate }}
      <br />
      <span class="bold-text">{{ attachment.modified }}</span>
    </p>
  }
  @if (attachment.modifiedBy) {
    <p>
      {{ 'modifiedBy' | translate }}
      <br />
      <span class="bold-text">{{ attachment.modifiedBy }}</span>
    </p>
  }
</ng-template>

<app-upload-task></app-upload-task>
